import { RevenueAPI } from "@/api/revenueAPI";
import {
  GET_YEARLY_REVENUE_BY_MONTH_SUCCESS,
  GET_YEARLY_REVENUE_BY_MONTH_ERROR,
  GET_YEARLY_REVENUE_BY_MONTH_REQUEST,
} from "@/redux/actions";
import {
  IRevenueMetricsByMonth,
  mapDataForRevenueMetrics,
} from "@/utils/mapDataForRevenueMetrics";
import { call, put, takeLatest } from "redux-saga/effects";

function* workerYearlyRevenueByMonth(action: {
  type: string;
  payload: string[];
}): Generator<any> {
  try {
    const data = yield call(
      RevenueAPI.getYearlyRevenueByMonth,
      action.payload
    ) as unknown as IRevenueMetricsByMonth[];

    yield put({
      type: GET_YEARLY_REVENUE_BY_MONTH_SUCCESS,
      payload: {
        yearlyRevenueByMonth: mapDataForRevenueMetrics(
          data as IRevenueMetricsByMonth[]
        ),
      },
    });
  } catch (error) {
    yield put({ type: GET_YEARLY_REVENUE_BY_MONTH_ERROR, payload: error });
  }
}

export function* watcherYearlyRevenueByMonth() {
  yield takeLatest(
    GET_YEARLY_REVENUE_BY_MONTH_REQUEST,
    workerYearlyRevenueByMonth
  );
}
